import api from './api';

export const contactService = {
  // Soumettre un message de contact (public)
  submit: async (data) => {
    try {
      const response = await api.post('/contact', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
      throw error;
    }
  },

  // Récupérer tous les messages (admin)
  getAll: async (page = 1) => {
    try {
      const response = await api.get(`/admin/contacts?page=${page}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des messages:', error);
      throw error;
    }
  },

  // Récupérer un message (admin)
  getById: async (id) => {
    try {
      const response = await api.get(`/admin/contacts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du message:', error);
      throw error;
    }
  },

  // Mettre à jour le statut (admin)
  updateStatut: async (id, statut) => {
    try {
      const response = await api.put(`/admin/contacts/${id}/statut`, { statut });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);
      throw error;
    }
  },

  // Marquer comme lu (admin)
  markAsRead: async (id) => {
    try {
      const response = await api.put(`/admin/contacts/${id}/statut`, { statut: 'lu' });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du marquage comme lu:', error);
      throw error;
    }
  },

  // Supprimer un message (admin)
  delete: async (id) => {
    try {
      const response = await api.delete(`/admin/contacts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression du message:', error);
      throw error;
    }
  },

  // Récupérer les statistiques (admin)
  getStatistiques: async () => {
    try {
      const response = await api.get('/admin/contacts/statistiques');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  }
};
